import { primitive } from 'styles/constants';

import { AppTakeoverConfig, TakeoverPdpItemConfig } from '../types';

const WARM_CREAM = '#F6EDDD';
const FONT_FAMILY = 'Flame-Bold';

const MENU_ITEM_COMMON: TakeoverPdpItemConfig = {
  sectionFontColor: primitive.$mayoEggWhite,
  headerFontColor: primitive.$mayoEggWhite,
};

export const elevation: AppTakeoverConfig = {
  splashScreen: {
    video: require('./splash.mp4'),
    durationMs: 2840,
  },
  fontFamily: FONT_FAMILY,
  homePage: {
    targetSimpleHomePageIds: ['721bb5b3-3775-4add-a0bd-153d5fb4c41c'],
    containerBackgroundColor: primitive.$bbqBrown,
    primaryButton: {
      backgroundColor: WARM_CREAM,
      _text: {
        color: primitive.$bbqBrown,
      },
      _pressed: {
        backgroundColor: primitive.$greyFive,
      },
    },
    deliveryButton: {
      _text: {
        color: WARM_CREAM,
      },
      _pressed: {
        backgroundColor: primitive.$greyThree,
      },
      borderColor: WARM_CREAM,
    },
    muteButtonCoachmarkArgs: null,
  },
  menu: {
    targetSectionIds: {
      // BK Classics
      'e896a667-807d-4ca2-be3a-f4ba990052af': {
        headerBackgroundColor: WARM_CREAM,
        headerBackgroundImage: require('./section-header.webp'),
        itemBackgroundColor: WARM_CREAM,
        sectionTileBackgroundImage: require('./primary-section-bg.webp'),
        fontColor: primitive.$mayoEggWhite,
      },
    },
  },

  pdp: {
    targetMenuItemIds: {
      // Whopper
      'eae5da38-28fb-4681-bcde-43abf07260eb': {
        ...MENU_ITEM_COMMON,
        overviewTopImage: require('./whopper-topper.webp'),
        headerBackgroundColor: '#572619',
        sectionBackgroundImage: require('./whopper-section-bg.webp'),
      },
      // Fries
      '9427d6a0-1f55-4c08-97dd-c7c370507468': {
        ...MENU_ITEM_COMMON,
        overviewTopImage: require('./fries-topper.webp'),
        headerBackgroundColor: '#D82A27',
        sectionBackgroundImage: require('./fries-section-bg.webp'),
      },
      // Onion Rings
      '484f44d8-399f-4678-b8ee-96e109619da8': {
        ...MENU_ITEM_COMMON,
        overviewTopImage: require('./onion-rings-topper.webp'),
        headerBackgroundColor: '#F18728',
        sectionBackgroundImage: require('./onion-rings-section-bg.webp'),
      },
      // Chicken Nuggets
      'a9a93d49-60f0-4c6f-b9ae-ae5cba45c403': {
        ...MENU_ITEM_COMMON,
        overviewTopImage: require('./nuggets-topper.webp'),
        headerBackgroundColor: '#FBA919',
        sectionBackgroundImage: require('./nuggets-section-bg.webp'),
      },
    },
    backgroundColor: WARM_CREAM,
    backgroundImage: require('./product-shot-bg.webp'),
    overviewBottomImageOffset: 100,
  },
  cart: {
    paymentProcessingVideo: require('./checkout.mp4'),
    paymentProcessingBackgroundColor: WARM_CREAM,
  },
};
